(function () {
  function updateBadge(badge, qty, managed, available) {
    if (available === false || available === 'false') {
      badge.className = 'lenz-stock-badge lenz-stock--out';
      badge.childNodes[badge.childNodes.length - 1].textContent = ' Out of Stock';
    } else if (managed === 'shopify' && qty > 0 && qty <= 5) {
      badge.className = 'lenz-stock-badge lenz-stock--low';
      badge.childNodes[badge.childNodes.length - 1].textContent = ' Low Stock: ' + qty + ' left';
    } else {
      badge.className = 'lenz-stock-badge lenz-stock--in';
      badge.childNodes[badge.childNodes.length - 1].textContent = ' In Stock';
    }
  }

  function processCard(badge) {
    /* Skip badges already rendered correctly by Liquid server-side */
    if (badge.dataset.managed !== undefined && badge.dataset.qty !== undefined) {
      /* Only re-process if the badge text is empty or stale (e.g. dynamic/AJAX cards) */
      var text = badge.textContent.trim();
      if (text === 'In Stock' || text === 'Out of Stock' || text.indexOf('Low Stock') > -1) {
        return; /* Liquid already rendered correct text — leave it alone */
      }
      var qty = parseInt(badge.dataset.qty, 10) || 0;
      var managed = badge.dataset.managed;
      var available = badge.dataset.available;
      updateBadge(badge, qty, managed, available);
      return;
    }

    /* Fallback: AJAX fetch for dynamically injected cards without data attributes */
    var card = badge.closest('product-info');
    if (!card) return;
    var url = card.getAttribute('data-url');
    if (!url) return;
    var match = url.match(/\/products\/([^/?#]+)/);
    if (!match) return;
    var handle = match[1];

    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var variants = p.variants || [];
        var variant = variants.find(function (v) { return v.available; }) || variants[0];
        if (!variant) return;
        updateBadge(badge, variant.inventory_quantity || 0, variant.inventory_management, variant.available);
      })
      .catch(function () {});
  }

  function init() {
    document.querySelectorAll('.lenz-stock-badge').forEach(processCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          var badges = node.querySelectorAll ? node.querySelectorAll('.lenz-stock-badge') : [];
          badges.forEach(processCard);
          if (node.classList && node.classList.contains('lenz-stock-badge')) processCard(node);
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
